// extracted by mini-css-extract-plugin
module.exports = {"SectionA2":"SectionA2_SectionA2__imf9g"};